import React, { useState } from 'react';

import { toast } from 'react-toastify';
import api from 'shared/services/api';
import { Textarea, Button, Space } from '@mantine/core';
import { useForm } from '@mantine/form';

const EditCommentDrawer = ({ id, onClose, onAdd, comment }) => {
  const [isLoading, setLoading] = useState<boolean>();

  const onSubmit = async values => {
    try {
      setLoading(true);
      await api({}).patch(`/api/recommendations/${id}/comment/${comment?.id}`, values);
      setLoading(false);
      toast.success('Komentarz został edytowany');
      onAdd();
      onClose();
    } catch {
      setLoading(false);
      toast.error(translations.global.somethingWentWrong);
    }
  };
  const form = useForm({
    initialValues: {
      comment: comment?.comment,
    },

    validate: {},
  });
  return (
    <>
      <form
        onSubmit={form.onSubmit(values => {
          onSubmit(values);
        })}>
        <Textarea label="Komentarz" {...form.getInputProps('comment')} />
        <Space h={10}></Space>
        <Button loading={isLoading} type="submit">
          Zapisz
        </Button>
      </form>
    </>
  );
};

export default EditCommentDrawer;
